window.$ = window.jQuery;

require('./modules/analytics/bootstrap');
require('./modules/app');
require('./modules/app.feedback.controller');
require('./modules/currency-switcher');
require('./modules/custombox');
require('./modules/global');
require('./modules/global.menu');
require('./modules/header.widgets');
require('./modules/components/widget-rating/widget-rating');
require('./modules/components/contact-form/send-contact-message');
require('./modules/components/feedback-recaptcha');
require('./modules/components/lazy-videos');
